import { Component, EventEmitter, Output } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { InputComponent } from '../input/input.component';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-table-search',
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, MatTableModule, MatIconModule, InputComponent],
  templateUrl: './table-search.component.html',
  styleUrl: './table-search.component.css',
})
export class TableSearchComponent {
  @Output() filterChanged = new EventEmitter<string>();
  iconName: string = 'search';
  textInputType: string = 'text';
  placeHolderText: string = $localize`Search`;
  searchValue = new FormControl('');

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.filterChanged.emit(filterValue);
  }
}
